module.exports = __webpack_public_path__ + "img/image2.bfac8567.png";